import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PlatformService } from 'src/app/services/platform.service';

@Component({
  selector: 'vl-refresh',
  standalone: true,
  imports: [],
  templateUrl: './refresh.component.html',
  styleUrl: './refresh.component.scss'
})
export class RefreshComponent {
  private platform: string = "";
  private accountId: string = "";
  private channelId: string = "";
  private context: string = ""

  constructor(private activatedRoute: ActivatedRoute, private platformService: PlatformService) {
    this.activatedRoute.params.subscribe((params) => {
      this.platform = <string>params['platform'];
    });
    this.activatedRoute.queryParams.subscribe((params) => {
      this.accountId = <string>params['accountId'];
      this.channelId = <string>params['channelId'];
      this.context = <string>params['context'];
    });
    const state = encodeURIComponent(JSON.stringify({
      accountId: this.accountId,
      channelId: this.channelId,
      context: this.context,
    }));
    location.replace(this.platformService.getAuthorizationUri(this.platform, state));
  }
}
